import { constants } from "~/constants";
import { SupportedLanguage } from "./SupportedLanguage";

export function getPreferredLanguage() {
  const supportedLanguageList = Object.values(SupportedLanguage);

  // On web we try to find a supported preferred language in navigator.languages
  for (const language of navigator.languages) {
    if (supportedLanguageList.includes(language as SupportedLanguage)) {
      return language;
    }
  }

  return constants.DEFAULT_LANGUAGE;
}
